import { FC, memo } from 'react'
import { useTranslation } from 'next-i18next'
import { TailSpin } from 'react-loader-spinner'
import styles from './RecommendedSpaceCardList.module.scss'

//type
import { RecommendedSpace } from 'types/space/recommended'

//component
import RecommendedSpaceCardComponent from 'components/cards/RecommendedSpaceCard'
import { Pagination } from 'components/Pagination'
import { AdBanner } from 'components/ads/AdBanner'
import { NHK_AREA_PAGE_BANNER_CONFIG } from 'constants/ads'

interface Props {
  list: RecommendedSpace[]
  totalCount: number
  currentPage?: number
  itemsPerPage?: number
  onPageChange?: (page: number) => void
  usePagination?: boolean
  isLoading?: boolean
  locale: string
}

const RecommendedSpaceCardList: FC<Props> = ({
  list,
  totalCount,
  currentPage = 1,
  itemsPerPage = 10,
  onPageChange,
  usePagination = false,
  isLoading = false,
  locale,
}: Props): JSX.Element => {
  const { t } = useTranslation()
  const showAdLocale = locale === 'en' || locale === 'zh_tw'

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <TailSpin height="100" width="100" color="#0b6ab3" ariaLabel="loading" />
      </div>
    )
  }

  return (
    <>
      <ul className={styles.list}>
        {list.map((recommended: RecommendedSpace, index) => {
          const showAdAfterSecond = list.length >= 2 && index === 1
          const showAdAtEndShortList = list.length === 1 && index === 0

          return (
            <li className={styles.listItem} key={index}>
              <RecommendedSpaceCardComponent
                space={recommended}
                position={index + 1} // リスト内での位置を渡す（1から開始）
              />
              {showAdLocale && (showAdAfterSecond || showAdAtEndShortList) && (
                <AdBanner {...NHK_AREA_PAGE_BANNER_CONFIG} />
              )}
            </li>
          )
        })}
      </ul>
      {totalCount === 0 ? (
        <p className={styles.noDataText}>{t('AREAS.CITY.SLUG.NO_LUGGAGE_DATA')}</p>
      ) : null}
      {usePagination && onPageChange && totalCount > itemsPerPage && (
        <Pagination
          page={currentPage}
          total={Math.ceil(totalCount / itemsPerPage)}
          onChangePage={onPageChange}
        />
      )}
    </>
  )
}

export default memo(RecommendedSpaceCardList)
